// extracted by mini-css-extract-plugin
export default {"array":"drawnUI_array__jDX9Y","item":"drawnUI_item__kx95L","submit-box":"drawnUI_submit-box__RAXEB"};